import { CircularProgress, CircularProgressProps } from '@mui/material';

type Props = {
  display: boolean;
  color?: CircularProgressProps['color'];
};
export function Spinner({ display, color }: Props) {
  return (
    <>
      {display && (
        <CircularProgress
          color={color ?? 'inherit'}
          sx={{ position: 'fixed', top: '50%', right: '50%' }}
        />
      )}
    </>
  );
}
